import { cn } from "@/lib/utils";

const MAP = {
  acknowledged: { label: "ACK", cls: "border-blue-500/40 text-blue-400 bg-blue-500/10" },
  classifying: { label: "CLASSIFYING", cls: "border-amber-500/40 text-amber-400 bg-amber-500/10 animate-pulse" },
  drafting_report: { label: "DRAFTING REPORT", cls: "border-amber-500/40 text-amber-400 bg-amber-500/10 animate-pulse" },
  report_ready: { label: "REPORT READY", cls: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10" },
  report_sent: { label: "SENT", cls: "border-emerald-600/50 text-emerald-300 bg-emerald-600/15" },
  send_failed: { label: "SEND FAILED", cls: "border-red-500/50 text-red-400 bg-red-500/10" },
  zzi_submitted: { label: "ZZI SUBMITTED", cls: "border-violet-500/50 text-violet-300 bg-violet-500/15" },
  pending: { label: "PENDING", cls: "border-amber-500/40 text-amber-400 bg-amber-500/10" },
  approved: { label: "APPROVED", cls: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10" },
  rejected: { label: "REJECTED", cls: "border-red-500/40 text-red-400 bg-red-500/10" },
  cancelled: { label: "CANCELLED", cls: "border-zinc-600 text-zinc-400 bg-zinc-800/50 line-through" },
};

export function StatusBadge({ status, className }) {
  const c = MAP[status] || { label: (status || "—").toUpperCase(), cls: "border-zinc-700 text-zinc-400 bg-zinc-800/50" };
  return (
    <span data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center px-2 py-0.5 rounded-sm border text-[10px] font-mono font-medium tracking-wider whitespace-nowrap", c.cls, className)}>
      {c.label}
    </span>
  );
}

const SEV = {
  high: "border-red-500/50 text-red-400 bg-red-500/10",
  medium: "border-amber-500/40 text-amber-400 bg-amber-500/10",
  info: "border-zinc-700 text-zinc-400 bg-zinc-800/50",
};
export function SeverityBadge({ severity, children }) {
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded-sm border text-[10px] font-mono tracking-wide", SEV[severity] || SEV.info)}>
      {children}
    </span>
  );
}
